import React from "react";
import { useTranslation } from "react-i18next";
import { getColorHex, getColorLabel } from "../../utils/productColors";

function ProductColorSwatches({
  colors = [],
  selected = "",
  onChange,
  readOnly = false,
  compact = false,
  hideLabel = false,
  label,
  className = "",
}) {
  const { t, i18n } = useTranslation();

  if (!colors.length) return null;

  const groupLabel = label || t("Color");

  return (
    <div
      className={`caf-product-colors${compact ? " caf-product-colors--compact" : ""}${
        hideLabel ? " caf-product-colors--no-label" : ""
      }${className ? ` ${className}` : ""}`}
    >
      {hideLabel ? null : (
        <span className="caf-product-colors__label">{groupLabel}</span>
      )}
      <div
        className="caf-product-colors__list"
        role={readOnly ? "list" : "radiogroup"}
        aria-label={groupLabel}
      >
        {colors.map((color) => {
          const isSelected = selected === color;
          const colorLabel = getColorLabel(color, i18n.language);
          const swatchStyle = { backgroundColor: getColorHex(color) };

          if (readOnly) {
            return (
              <span
                key={color}
                className="caf-product-colors__swatch caf-product-colors__swatch--readonly"
                style={swatchStyle}
                title={colorLabel}
                aria-label={colorLabel}
              />
            );
          }

          return (
            <button
              key={color}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={colorLabel}
              title={colorLabel}
              className={`caf-product-colors__swatch${
                isSelected ? " caf-product-colors__swatch--selected" : ""
              }`}
              style={swatchStyle}
              onClick={() => onChange?.(color)}
            />
          );
        })}
      </div>
      {!readOnly && selected ? (
        <span className="caf-product-colors__selected">{getColorLabel(selected, i18n.language)}</span>
      ) : null}
    </div>
  );
}

export default ProductColorSwatches;
